module.exports = __webpack_public_path__ + "static/media/sgc.299531b2.svg";